import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { Chevron, Details, Summary, SummaryContent } from './styles';

interface AccordionProps {
  summary: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({
  summary,
  defaultOpen = false,
  children,
}) => {
  // O estado precisa acompanhar o do <details>: antes o `open` era fixado no
  // valor inicial sem ouvir o toggle, então qualquer re-render da tela voltava
  // o accordion para o estado inicial e o atendente não conseguia fechá-lo.
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Details
      open={open}
      onToggle={(event: React.SyntheticEvent<HTMLDetailsElement>) =>
        setOpen((event.target as HTMLDetailsElement).open)
      }
    >
      <Summary>
        <SummaryContent>{summary}</SummaryContent>
        <Chevron open={open} aria-hidden="true">
          <FaChevronDown size={12} />
        </Chevron>
      </Summary>
      <div>{children}</div>
    </Details>
  );
};

export default Accordion;
